import React, {useEffect} from 'react';
import {AppBar, ButtonResponsive, ConfirmDialog, ListViewMode, LoadingProgress} from "../../components";
import {DialogContentText} from "@mui/material";
import {getAppUserCuadreDetalle} from "../../services";
import {agregarAdminCuadre} from "../../redux/reducers/adminCuadresReducers";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IAdminCuadreDetalle} from "../../redux/types/IAdminCuadre";
import CuadrePagos from "./CuadrePagos";
import {FilterList} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router-dom";

export default function  CuadreInfo() {
    const { status} = useAppSelector(state=>state.adminCuadres);
    const navigate = useNavigate();
    const {pathname} = useLocation();

    const dispatch = useAppDispatch();
    const [bancosPagos, setBancosPagos] = React.useState<IAdminCuadreDetalle[]>();
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getAppUserCuadreDetalle().then(({data})=>{
            setBancosPagos(data)
        }).finally(()=>setLoading(false))
    }, [setLoading, setBancosPagos]);

    let crearCuadre = ()=>{
        let monto = bancosPagos?.reduce((a, b)=> a + (b.monto ?? 0), 0);
        if(monto){
            dispatch(agregarAdminCuadre(monto)).then(res=>{
                if(res.payload){
                    setBancosPagos(undefined)
                }
            })
        }
    }

    return <>
        <AppBar title={"Pagos para cuadre"} />

        <section className="contentInner">
            {(loading || status === "loading") && <LoadingProgress vh/>}
            <ListViewMode>
                <ButtonResponsive icon={<FilterList/>} text={"Hacer Cuadre"}
                                  onClick={()=> navigate(pathname,{state:{confirmDialog: true}})}
                />
            </ListViewMode>
            <CuadrePagos bancosPagos={bancosPagos}/>
        </section>
        <ConfirmDialog  onConfirm={crearCuadre}>
            <DialogContentText>
                Deseas crear un nuevo cuadre con estos pagos?
            </DialogContentText>
        </ConfirmDialog>
    </>;


}